import { API_MYEDUZZ } from 'settings';
import type { IPendingAffiliateSummaryCount, IPendingAffiliateSummaryList } from 'v2/interfaces/affiliate';
import { apiServiceProxy } from 'v2/services/api-proxy';

import type { ApiServiceProxy } from '../api-proxy';

class PendingAffiliateService {
  constructor(private apiService: ApiServiceProxy) {}

  public async getPendingAffiliatesSummaryCount(force?: boolean) {
    const params = force ? 'format=count&cache_clear=true' : 'format=count';
    return this.apiService.get<IPendingAffiliateSummaryCount>(`${API_MYEDUZZ}/affiliates/pending-summary?${params}`);
  }

  public async getPendingAffiliatesSummaryList(force?: boolean) {
    const params = force ? 'format=list&cache_clear=true' : 'format=list';
    return this.apiService.get<IPendingAffiliateSummaryList>(`${API_MYEDUZZ}/affiliates/pending-summary?${params}`);
  }

  public async moderateAffiliate(affiliateId: number, status: 'A' | 'R') {
    return this.apiService.post(`${API_MYEDUZZ}/affiliates/${affiliateId}/moderate`, { status });
  }
}

export const pendingAffiliateService = new PendingAffiliateService(apiServiceProxy);
